module.exports = __webpack_public_path__ + "img/risks-injury.c43fa2ab.svg";